<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle() }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isPassedFormValid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-text-field
                        label="施設名"
                        :value="editedItem.fa_name"
                        v-bind="readOnlyTextFieldProps"
                        auto-grow
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        :items="$facility.openingStatuses"
                        v-model="editedItem.opening_status"
                        label="開設状況"
                        v-bind="selectProps"
                        :rules="[$validation.rules.required]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <datetime-picker
                    :title="'開設日時'"
                    :datetime="editedItem.opening_date"
                    :disabled="screen.readOnly"
                    :selectedDatetime.sync="editedItem.opening_date"
                    :is-clear-when-init="true"
                    :vee-validate="false"
                    :valid-datetime.sync="editedItem.valid_opening_date"
                  />
                  <datetime-picker
                    :title="'閉鎖日時'"
                    :datetime="editedItem.closing_date"
                    :disabled="screen.readOnly"
                    :selectedDatetime.sync="editedItem.closing_date"
                    :is-clear-when-init="true"
                    :vee-validate="false"
                    :valid-datetime.sync="editedItem.valid_closing_date"
                  />
                  <template v-if="facilityClass.isShelter()">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.max_capacity"
                          label="最大収容人数"
                          suffix="人"
                          v-bind="readOnlyTextFieldProps"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.seating_capacity"
                          label="避難者数"
                          suffix="人"
                          v-bind="textFieldProps(4)"
                          :rules="[$validation.rules.numeric]"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.current_seating_capacity"
                          label="現在の避難者数"
                          suffix="人"
                          v-bind="readOnlyTextFieldProps"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.qr_enter_num"
                          label="避難者数のうちQRコード登録者"
                          suffix="人"
                          v-bind="readOnlyTextFieldProps"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.max_household"
                          label="最大収容世帯数"
                          suffix="世帯"
                          v-bind="readOnlyTextFieldProps"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.seating_household"
                          label="現在の避難者世帯数"
                          suffix="世帯"
                          v-bind="textFieldProps(4)"
                          :rules="[$validation.rules.numeric]"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.exit_num"
                          label="退所者数"
                          suffix="人"
                          v-bind="textFieldProps(4)"
                          :rules="[$validation.rules.numeric]"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-text-field
                          v-model="editedItem.qr_exit_num"
                          label="退所者数のうちQRコード登録者"
                          suffix="人"
                          v-bind="readOnlyTextFieldProps"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                  <v-row v-if="facilityClass.isInspection()">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field
                        v-model="editedItem.arrival_num"
                        label="到着済人数"
                        suffix="人"
                        v-bind="textFieldProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="facilityClass.isInspection()">
                    <v-col cols="12" sm="12" md="6" lg="4">
                      <v-text-field
                        v-model="editedItem.bus_num"
                        label="検査済バス車両数"
                        suffix="台"
                        v-bind="textFieldProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="4">
                      <v-text-field
                        v-model="editedItem.bus_insp_ngnum"
                        label="検査済バス車両数のうちバス検査不合格数"
                        suffix="台"
                        v-bind="textFieldProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="facilityClass.isInspection()">
                    <v-col cols="12" sm="12" md="6" lg="4">
                      <v-text-field
                        v-model="editedItem.car_num"
                        label="検査済乗用車数"
                        suffix="台"
                        v-bind="textFieldProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="4">
                      <v-text-field
                        v-model="editedItem.car_insp_ngnum"
                        label="検査済乗用車数のうち乗用車検査不合格数"
                        suffix="台"
                        v-bind="textFieldProps(4)"
                        :rules="[$validation.rules.numeric]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="facilityClass.isShelter()">
                    <v-col class="caption search-item-caption">
                      ライフライン状況
                    </v-col>
                  </v-row>
                  <v-row v-if="facilityClass.isShelter()">
                    <v-col
                      cols="12"
                      sm="3"
                      md="3"
                      lg="3"
                      v-for="(label, key, index) in $facility.lifelines"
                      :key="index"
                    >
                      <v-select
                        :items="$facility.lifelineStatuses"
                        v-model="$data['editedItem'][key]"
                        :label="label"
                        v-bind="selectProps"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="facilityClass.isInspection()">
                    <v-col cols="12" sm="6" md="4" lg="3">
                      <v-select
                        v-model="editedItem.congest_situation"
                        :items="$facility.congestSituations"
                        label="混雑状況"
                        v-bind="selectProps"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="editedItem.lodine_distri_place_flg"
                        label="安定ヨウ素剤配布場所に設定"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-textarea
                        v-model="editedItem.free_input"
                        label="備考"
                        v-bind="textFieldProps(500)"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="save"
                :disabled="!isPassedFormValid"
              >
                更新
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="close">
                キャンセル
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-overlay :value="dialogOverlay" opacity="1" color="white">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          原子力災害関係施設状況は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="6">
            <v-select
              v-model="searchItem.facilityClass"
              :items="$facility.facilityClasses"
              label="原子力防災施設区分"
              v-bind="selectPropsForSearch"
              @change="resetCheckItems"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.municipality"
              :items="municipalities"
              :label="municipalityTitle(searchItem.facilityClass)"
              @change="changeMunicipality"
              :disabled="!hasFacilityClass(searchItem)"
              v-bind="selectPropsForSearchMunicipality"
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.area"
              :items="$facility.areasForSearch(areas)"
              :label="areaTitle(searchItem.facilityClass)"
              :disabled="!hasMunicipality(searchItem)"
              v-if="searchable.area"
              v-bind="selectPropsForSearch"
              @change="resetCheckItems"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.openingStatuses"
              :items="$facility.openingStatuses"
              label="開設状況"
              multiple
              :disabled="!hasItems(searchItem, items)"
              v-bind="selectPropsForSearch"
              @change="resetPage"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleOpeningStatus">
                  <v-list-item-action>
                    <v-icon :color="iconColor(searchItem.openingStatuses)">
                      {{ icon(likesAllOpeningStatus, likesSomeOpeningStatus) }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>全て</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="searchItem.tempFacilityDivision"
              :items="$facility.tempFacilityFlags"
              label="臨時施設区分"
              :disabled="!hasItems(searchItem, items)"
              v-bind="selectPropsForSearch"
              @change="resetPage"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3" class="pt-0">
            <v-checkbox
              v-model="searchItem.lodineDistriPlaceType"
              :disabled="!hasItems(searchItem, items)"
              label="安定ヨウ素剤配布場所のみ表示"
              class="pa-0 ma-0"
            ></v-checkbox>
          </v-col>
        </v-row>
        <div class="ml-3 mb-4">
          部分一致で検索することができます。<br />
          検索は施設名、施設名（カナ）、施設名（英名）、施設住所、施設管理者／責任者、備考の項目が対象です。<br />
          スペースを挟み、複数の語句で検索することはできません。<br />
        </div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="searchItem.freeText"
              label="フリーテキスト"
              placeholder="施設名、施設名（カナ）、施設名（英名）、施設住所、施設管理者/責任者、備考から検索"
              :disabled="!hasItems(searchItem, items)"
              v-bind="textFieldPropsForSearch"
              @input="resetPage"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
      </v-container>
      <v-row v-if="hasItems(searchItem, items) && !screen.readOnly">
        <v-col cols="12" md="6">
          <v-btn
            class="mx-2"
            color="primary"
            :disabled="!isSelected(selected)"
            @click="openBulkEdit"
          >
            一括編集
          </v-btn>
          <div class="mt-2 ml-1 caption">
            ※一括編集画面が開き、チェックした施設状況を一括で編集できます。
          </div>
        </v-col>
        <v-col cols="12" md="6" class="text-right float-right">
          <v-btn
            class="mx-2"
            color="primary"
            :disabled="!isSelected(selected)"
            @click="bulkUpdate"
          >
            一括更新
          </v-btn>
          <div class="mt-2 ml-1 caption">
            ※一覧で編集した内容を一括で更新できます。
          </div>
        </v-col>
      </v-row>
      <no-check-top-operation-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        locale="ja-jp"
        item-key="fa_id"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
        :show-select="!screen.readOnly"
        v-if="hasItems(searchItem, items)"
        must-sort
        dispMode="nowrap"
        class="fixedWidth"
        ref="resetPagination"
      >
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
        >
          <v-simple-checkbox
            :value="isSelected"
            @input="
              select($event);
              item.read_only_row = isSelected;
              changeCheckItem(item, isSelected);
            "
            :ripple="false"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
          </v-simple-checkbox>
        </template>
        <template v-slot:[`item.disp_no`]="{ item }">
          {{ $facility.facilityName(item) }}
        </template>
        <template v-slot:[`item.fa_name_kana`]="{ item }">
          {{ item.fa_name_kana }}
        </template>
        <template v-slot:[`item.fa_name_en`]="{ item }">
          {{ item.fa_name_en }}
        </template>
        <template v-slot:[`item.opening_status`]="{ item }">
          <eva-facility-status-list-select
            v-model="item.opening_status"
            :items="$facility.openingStatuses"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="$facility.openingStatusName(item)"
          />
        </template>
        <template v-slot:[`item.opening_date`]="{ item }"
          ><template v-if="screen.readOnly || item.read_only_row">
            {{ $dateUtils.formatDatetime(item.opening_date) }}</template
          ><template v-else
            ><a
              class="text-decoration-underline"
              @click="editDatetime('開設日時', item, 'opening_date')"
              >{{
                item.opening_date
                  ? $dateUtils.formatDatetime(item.opening_date)
                  : "開設日時選択"
              }}</a
            ></template
          >
        </template>
        <template v-slot:[`item.closing_date`]="{ item }">
          <template v-if="screen.readOnly || item.read_only_row">
            {{ $dateUtils.formatDatetime(item.closing_date) }}</template
          ><template v-else
            ><a
              class="text-decoration-underline"
              @click="editDatetime('閉鎖日時', item, 'closing_date')"
              >{{
                item.closing_date
                  ? $dateUtils.formatDatetime(item.closing_date)
                  : "閉鎖日時選択"
              }}</a
            ></template
          >
        </template>
        <template v-slot:[`item.seating_capacity`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.seating_capacity"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.seating_capacity"
          />
        </template>
        <template v-slot:[`item.seating_household`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.seating_household"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.seating_household"
          />
        </template>
        <template v-slot:[`item.exit_num`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.exit_num"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.exit_num"
          />
        </template>
        <template v-slot:[`item.congest_situation`]="{ item }">
          <eva-facility-status-list-select
            v-model="item.congest_situation"
            :items="$facility.congestSituations"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="$facility.congestionSituationName(item)"
          />
        </template>
        <template v-slot:[`item.lifeline_status`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="viewLifelineStatus(item)"
          >
            詳細
          </v-btn>
        </template>
        <template v-slot:[`item.arrival_num`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.arrival_num"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.arrival_num"
          />
        </template>
        <template v-slot:[`item.bus_num`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.bus_num"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.bus_num"
          />
        </template>
        <template v-slot:[`item.bus_insp_ngnum`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.bus_insp_ngnum"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.bus_insp_ngnum"
          />
        </template>
        <template v-slot:[`item.car_num`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.car_num"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.car_num"
          />
        </template>
        <template v-slot:[`item.car_insp_ngnum`]="{ item }">
          <eva-facility-status-list-text-field
            v-model="item.car_insp_ngnum"
            :read-only="screen.readOnly"
            :facility-status="item"
            :text="item.car_insp_ngnum"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
            参照
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="editItem(item)"
            v-if="!screen.readOnly"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            編集
          </v-btn>
        </template>
        <template v-slot:[`item.update`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="updateItem(item)"
            v-if="!screen.readOnly"
            :disabled="item.read_only_row"
          >
            更新
          </v-btn>
        </template>
      </no-check-top-operation-data-table>
    </v-sheet>
    <confirm-dialog ref="confirmBulkUpdate" />
    <nuclear-disaster-facility-detail
      ref="facility"
      v-if="hasItems(searchItem, items)"
    />
    <lifeline-status-detail
      ref="lifelineStatus"
      v-if="hasItems(searchItem, items)"
    />
    <v-dialog v-model="dialogBulkEdit" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle(true) }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="bulkEditForm" v-model="isPassedbulkEditFormValid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-select
                    :items="$facility.openingStatuses"
                    v-model="editedItem.opening_status"
                    label="開設状況"
                    v-bind="selectProps"
                    :rules="[$validation.rules.required]"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <datetime-picker
                :title="'開設日時'"
                :datetime="editedItem.opening_date"
                :selected-datetime.sync="editedItem.opening_date"
                :is-clear-when-init="true"
                :vee-validate="false"
                :valid-datetime.sync="editedItem.valid_opening_date"
              />
              <datetime-picker
                :title="'閉鎖日時'"
                :datetime="editedItem.closing_date"
                :selected-datetime.sync="editedItem.closing_date"
                :is-clear-when-init="true"
                :vee-validate="false"
                :valid-datetime.sync="editedItem.valid_closing_date"
              />
              <v-row v-if="facilityClass.isInspection()">
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-select
                    v-model="editedItem.congest_situation"
                    :items="$facility.congestSituations"
                    label="混雑状況"
                    v-bind="selectProps"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row dense v-if="facilityClass.isShelter()">
                <v-col class="caption search-item-caption">
                  ライフライン状況
                </v-col>
              </v-row>
              <v-row v-if="facilityClass.isShelter()">
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                  v-for="(label, key, index) in $facility.lifelines"
                  :key="index"
                >
                  <v-select
                    :items="$facility.lifelineStatuses"
                    v-model="$data['editedItem'][key]"
                    :label="label"
                    v-bind="selectProps"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            color="primary"
            @click="bulkEdit"
            :disabled="!isPassedbulkEditFormValid"
          >
            一括編集
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="closeBulkEdit">
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="dialogOverlay" opacity="1" color="white">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <confirm-dialog ref="confirmUpdate" />
    <datetime-dialog ref="editDatetime" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import config from "@/js/const";
import Facility from "@/plugins/facility";
import DateUtils from "@/plugins/date-utils";
import { ScreenId } from "@/js/value-objects/screen-id";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import { FacilityClass } from "@/js/value-objects/facility-class";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { EvaFacilityStatusTranslator } from "@/js/translators/evaFacilityStatusTranslator";
import { SaveType } from "@/js/value-objects/save-type";
import EvaFacilityStatusListTextField from "@/components/facility/EvaFacilityStatusListTextField";
import EvaFacilityStatusListSelect from "@/components/facility/EvaFacilityStatusListSelect";

const evaFacilityStatusRepository = RepositoryFactory.get("evaFacilityStatus");
Vue.use(Facility, DateUtils, Disaster);
const SEARCH_ITEM = Object.freeze({
  municipality: null,
  area: null,
  openingStatuses: [],
  freeText: "",
  facilityClass: "",
  tempFacilityDivision: "",
  lodineDistriPlaceType: false
});
const FACILITY_STATUS_ITEM = Object.freeze({
  // 施設ID
  fa_id: "",
  // 開設状況
  opening_status: "",
  // 開設日時
  opening_date: "",
  // 開設日時が有効な日時か否か
  valid_opening_date: false,
  // 閉鎖日時
  closing_date: "",
  // 閉鎖日時が有効な日時か否か
  valid_closing_date: false,
  // 電気
  electricity: "",
  // ガス
  gas: "",
  // 水道
  water_supply: "",
  // 電話
  phone: "",
  // 備考
  free_input: "",
  // 収容世帯数
  seating_household: "",
  // 収容人数
  seating_capacity: "",
  // 退所者人数
  exit_num: "",
  // 混雑状況
  congest_situation: "",
  // 到着予定人数
  arrival_num: "",
  // バス車両数
  bus_num: "",
  // バス検査不合格数
  bus_insp_ngnum: "",
  // 乗用車数
  car_num: "",
  // 乗用車不合格数
  car_insp_ngnum: "",
  // 安定ヨウ素剤配布場所
  lodine_distri_place_flg: ""
});
const SEARCHABLE = Object.freeze({
  area: false
});
export default {
  mixins: [messageUtils],

  components: {
    EvaFacilityStatusListSelect,
    EvaFacilityStatusListTextField,
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    NuclearDisasterFacilityDetail: () =>
      import("@/components/facility/NuclearDisasterFacilityDetail"),
    LifelineStatusDetail: () =>
      import("@/components/facility/LifelineStatusDetail"),
    DatetimePicker: () => import("@/components/DatetimePicker"),
    DatetimeDialog: () => import("@/components/facility/DatetimeDialog"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    NoCheckTopOperationDataTable: () =>
      import("@/components/ui/NoCheckTopOperationDataTable")
  },

  data: () => ({
    config: config,
    overlay: false,
    dialogOverlay: false,
    dialog: false,
    dialogBulkEdit: false,
    screen: null,
    items: [],
    editedItems: {},
    editedIndex: -1,
    searchItem: cloneDeep(SEARCH_ITEM),
    editedItem: cloneDeep(FACILITY_STATUS_ITEM),
    defaultItem: cloneDeep(FACILITY_STATUS_ITEM),
    searchable: cloneDeep(SEARCHABLE),
    municipalities: [],
    areas: [],
    selected: [],
    facilityClass: FacilityClass.factoryShelter(),
    isPassedFormValid: false,
    isPassedbulkEditFormValid: false
  }),

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  computed: {
    headers() {
      let headers = [
        {
          text: "フリーテキスト",
          align: " d-none",
          value: "fa_id",
          filter: this.freeTextFilter
        },
        {
          text: "原子力防災施設区分",
          align: " d-none",
          value: "facility_class",
          filter: this.facilityClassFilter
        },
        {
          text: "地域（地区）",
          align: " d-none",
          value: "eva_area_code_list",
          filter: this.areaFilter
        },
        {
          text: "臨時施設区分",
          align: " d-none",
          value: "temp_facility_flg",
          filter: this.tempFacilityDivisionFilter
        },
        {
          text: "安定ヨウ素剤配布場所",
          align: " d-none",
          value: "lodine_distri_place_flg",
          filter: this.lodineDistriPlaceTypeFilter
        },
        {
          text: "施設名",
          align: "start",
          value: "disp_no"
        },
        {
          text: "施設名（カナ）",
          align: "start",
          value: "fa_name_kana"
        },
        {
          text: "施設名（英名）",
          align: "start",
          value: "fa_name_en"
        },
        {
          text: "開設状況",
          value: "opening_status",
          filter: this.openingStatusFilter,
          width: 150
        },
        {
          text: "開設日時",
          value: "opening_date"
        },
        {
          text: "閉鎖日時",
          value: "closing_date"
        },
        {
          text: "最大収容人数",
          value: "max_capacity",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "避難者数",
          value: "seating_capacity",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "現在の避難者数",
          value: "current_seating_capacity",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "避難者数のうち\nQRコード登録者",
          value: "qr_enter_num",
          view: {
            isMeeting: false,
            isInspection: false
          },
          class: "text-pre"
        },
        {
          text: "最大収容世帯数",
          value: "max_household",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "現在の避難者世帯数",
          value: "seating_household",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "退所者数",
          value: "exit_num",
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "退所者数のうち\nQRコード登録者",
          value: "qr_exit_num",
          view: {
            isMeeting: false,
            isInspection: false
          },
          class: "text-pre"
        },
        {
          text: "到着済人数",
          value: "arrival_num",
          view: {
            isShelter: false,
            isMeeting: false
          }
        },
        {
          text: "検査済バス車両数",
          value: "bus_num",
          view: {
            isShelter: false,
            isMeeting: false
          }
        },
        {
          text: "検査済バス車両数のうち\nバス検査不合格数",
          value: "bus_insp_ngnum",
          view: {
            isShelter: false,
            isMeeting: false
          },
          class: "text-pre"
        },
        {
          text: "検査済乗用車数",
          value: "car_num",
          view: {
            isShelter: false,
            isMeeting: false
          }
        },
        {
          text: "検査済乗用車数のうち\n乗用車検査不合格数",
          value: "car_insp_ngnum",
          view: {
            isShelter: false,
            isMeeting: false
          },
          class: "text-pre"
        },
        {
          text: "混雑状況",
          value: "congest_situation",
          view: {
            isShelter: false,
            isMeeting: false
          }
        },
        {
          text: "ライフライン状況",
          value: "lifeline_status",
          sortable: false,
          view: {
            isMeeting: false,
            isInspection: false
          }
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          width: 170
        },
        {
          text: "更新",
          value: "update",
          sortable: false
        }
      ];
      if (this.screen.readOnly) {
        headers = headers.filter(header => header.value !== "update");
      }
      if (!this.searchItem.facilityClass) {
        return this.$facility.filteredHeaders(headers, "isShelter");
      }
      const facilityClass = FacilityClass.factory(
        this.searchItem.facilityClass
      );
      if (facilityClass.isShelter()) {
        return this.$facility.filteredHeaders(headers, "isShelter");
      }
      if (facilityClass.isMeeting()) {
        return this.$facility.filteredHeaders(headers, "isMeeting");
      }
      if (facilityClass.isInspection()) {
        return this.$facility.filteredHeaders(headers, "isInspection");
      }
      return headers;
    },

    formTitle: function() {
      return function(isBulkEdit = false) {
        if (!this.searchItem.facilityClass) {
          return "";
        }
        let type = "";
        if (isBulkEdit === true) {
          type = "一括編集";
        } else {
          type = "編集";
        }
        const facilityClass = FacilityClass.factory(
          this.searchItem.facilityClass
        );
        type += `（${facilityClass.name()}）`;
        return `原子力災害関係施設状況の${type}`;
      };
    },

    sort() {
      return {
        by: ["disp_no"],
        desc: [false]
      };
    },

    formControlProps: () => {
      return function(placeholder, counter = null) {
        const formControlProps = this.$formControlProps(
          this.screen.readOnly,
          counter
        );
        Object.assign(formControlProps, {
          placeholder: placeholder
        });
        return formControlProps;
      };
    },

    textFieldProps: () => {
      return function(counter = null) {
        const formControlProps = this.$formControlProps(
          this.screen.readOnly,
          counter
        );
        Object.assign(formControlProps, {
          placeholder: this.config.PLACEHOLDER_INPUT
        });
        return formControlProps;
      };
    },

    textareaProps: () => {
      return function(counter = null) {
        return this.textFieldProps(counter);
      };
    },

    selectProps() {
      const formControlProps = this.$formControlProps(this.screen.readOnly);
      Object.assign(formControlProps, {
        placeholder: this.config.PLACEHOLDER_SELECT
      });
      return formControlProps;
    },

    selectPropsForSearchMunicipality() {
      return {
        placeholder: config.PLACEHOLDER_SELECT,
        outlined: true
      };
    },

    selectPropsForSearch() {
      return {
        placeholder: config.PLACEHOLDER_SELECT,
        clearable: true,
        outlined: true
      };
    },

    textFieldPropsForSearch() {
      return {
        clearable: true,
        outlined: true,
        appendIcon: "mdi-magnify"
      };
    },

    readOnlyTextFieldProps() {
      return {
        placeholder: config.PLACEHOLDER_SP,
        disabled: true
      };
    },

    likesAllOpeningStatus() {
      return (
        this.searchItem.openingStatuses.length ===
        this.$facility.openingStatuses.length
      );
    },

    likesSomeOpeningStatus() {
      return (
        this.searchItem.openingStatuses.length > 0 &&
        !this.likesAllOpeningStatus
      );
    },

    iconColor: function() {
      return function(items) {
        return items.length > 0 ? "indigo darken-4" : "";
      };
    },

    icon: function() {
      return function(likesAllItem, likesSomeItem) {
        if (likesAllItem) return "mdi-close-box";
        if (likesSomeItem) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogBulkEdit(val) {
      val || this.closeBulkEdit();
    },
    searchItem: {
      handler: function(newItem) {
        this.searchable = cloneDeep(SEARCHABLE);
        if (
          !newItem.facilityClass ||
          FacilityClass.factory(newItem.facilityClass).isShelterOrMeeting()
        ) {
          Object.assign(this.searchable, {
            area: true
          });
        }
      },
      deep: true
    },
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize(isAfterSaved = false) {
      this.overlay = true;
      this.screen = this.$screenOperationAuthority(
        ScreenId.SF1405,
        ScreenId.SF1406
      );
      if (!isAfterSaved) {
        this.facilityClass = FacilityClass.factoryShelter();
        Object.assign(this.searchItem, {
          facilityClass: this.facilityClass.value
        });
      }
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });
      if (isAfterSaved) {
        await this.$store
          .dispatch("evaFacilityStatus/loadEvaFacilityStatus", {
            screenId: this.screen.screenId,
            municipality: this.searchItem.municipality,
            disasterNo: this.$disaster.disaster_no
          })
          .then(() => {
            this.items = this.$store.state.evaFacilityStatus.data.results;
          })
          .catch(e => {
            this.handleError(e, this.screenId, "aggregation-menu");
          });
        this.selected = [];
        this.resetValidationAll();
      }
      this.overlay = false;
      this.dialogOverlay = false;
    },

    /**
     * 原子力防災施設区分に応じて
     * "市町村" / "避難元所属市町村"
     * を取得する
     */
    municipalityTitle(facilityClass) {
      if (FacilityClass.factory(facilityClass).isShelterOrMeeting()) {
        return "避難元所属市町村";
      }
      return "市町村";
    },

    /**
     * 原子力防災施設区分に応じて
     * "地域（地区）" / "避難元所属地域（地区）"
     * を取得する
     */
    areaTitle(facilityClass) {
      if (FacilityClass.factory(facilityClass).isShelterOrMeeting()) {
        return "避難元所属地域（地区）";
      }
      return "地域（地区）";
    },

    async changeMunicipality(municipality) {
      this.overlay = true;
      this.items = [];
      this.resetCheckItems();
      this.areas = AllAreaTranslator.toAreasByMunicipality(
        this.$store.state.allArea.areas,
        municipality
      );
      await this.$store
        .dispatch("evaFacilityStatus/loadEvaFacilityStatus", {
          screenId: this.screen.screenId,
          municipality,
          disasterNo: this.$disaster.disaster_no
        })
        .then(() => {
          this.items = this.$store.state.evaFacilityStatus.data.results;
        })
        .catch(e => {
          this.handleGetError(e);
        });
      Object.assign(this.searchItem, { area: "" });
      this.overlay = false;
    },

    areaFilter(value) {
      if (!this.searchable.area) {
        return true;
      }
      if (!this.searchItem.area) {
        return true;
      }
      return value.some(area => {
        return area === this.searchItem.area;
      });
    },

    facilityClassFilter(value) {
      if (!this.searchItem.facilityClass) {
        return true;
      }
      return value === this.searchItem.facilityClass;
    },

    tempFacilityDivisionFilter(value) {
      if (!this.searchItem.tempFacilityDivision) {
        return true;
      }
      return value === this.searchItem.tempFacilityDivision;
    },

    lodineDistriPlaceTypeFilter(value) {
      if (!this.searchItem.lodineDistriPlaceType) {
        return true;
      }
      return value === "1";
    },

    openingStatusFilter(value) {
      if (!this.searchItem.openingStatuses) {
        return true;
      }
      if (this.searchItem.openingStatuses.length === 0) {
        return true;
      }
      if (this.likesAllOpeningStatus) {
        return true;
      }
      const hasOpeningStatus = this.searchItem.openingStatuses.some(result => {
        return value === result;
      });
      if (hasOpeningStatus) {
        return true;
      }
    },

    freeTextFilter(value) {
      const freeText = this.searchItem.freeText;
      if (freeText === "" || freeText === null) {
        return true;
      }
      const item = this.items.find(item => item.fa_id === value);
      if (item) {
        const hasFacilityName = item.fa_name.includes(freeText);
        if (hasFacilityName) {
          return true;
        }
        const hasFacilityNameKana = item.fa_name_kana.includes(freeText);
        if (hasFacilityNameKana) {
          return true;
        }
        const hasFacilityNameEn = item.fa_name_en.includes(freeText);
        if (hasFacilityNameEn) {
          return true;
        }
        const hasAddress = item.fa_address.includes(freeText);
        if (hasAddress) {
          return true;
        }
        const hasPerson = item.fa_respons_person.includes(freeText);
        if (hasPerson) {
          return true;
        }
        const hasRemarks =
          item.free_input && item.free_input.includes(freeText);
        if (hasRemarks) {
          return true;
        }
      }
    },

    async viewItem(item) {
      await this.$refs.facility.open(
        item,
        this.municipalities,
        this.$store.state.allArea.areas
      );
    },

    async viewLifelineStatus(item) {
      await this.$refs.lifelineStatus.open(item);
    },

    editItem(item) {
      // 安定ヨウ素剤配布場所のチェックボックス用値変換
      item["lodine_distri_place_flg"] = this.changeValType(
        item.lodine_distri_place_flg,
        false
      );
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.facilityClass = FacilityClass.factory(
        this.editedItem.facility_class
      );
      this.dialog = true;
    },

    async updateItem(item) {
      const message = `${item.fa_name}の施設状況を変更しますか？`;
      const result = await this.$refs.confirmUpdate.open(message, "更新");
      if (!result) {
        return false;
      }
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      await this.save(SaveType.factoryRowUpdate());
    },

    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(saveType) {
      if (!(saveType instanceof SaveType)) {
        saveType = SaveType.factoryUpdate();
      }
      if (saveType.isUpdate()) {
        if (this.$refs.form.validate() === false) {
          return;
        }
        if (this.validateDatetime() === false) {
          return;
        }
        this.dialogOverlay = true;
      }
      // 安定ヨウ素剤配布場所フラグのBooleanの値を数値(文字列)に変換
      this.editedItem["lodine_distri_place_flg"] = this.changeValType(
        this.editedItem.lodine_distri_place_flg,
        true
      );
      const payload = await EvaFacilityStatusTranslator.toPayload(
        this.$disaster.disaster_no,
        this.editedItem,
        saveType
      );
      this.clearMessage();
      await evaFacilityStatusRepository
        .update(ScreenId.SF1407, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });
      await this.initialize(true);
      if (saveType.isUpdate()) {
        await this.close();
      }
    },

    openBulkEdit() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialogBulkEdit = true;
      this.resetValidationAll();
      this.facilityClass = FacilityClass.factory(this.searchItem.facilityClass);
    },

    async bulkEdit() {
      if (this.$refs.bulkEditForm.validate() === false) {
        return;
      }
      if (this.validateDatetime() === false) {
        return;
      }
      this.dialogOverlay = true;
      this.clearMessage();
      const list = [];
      for (const item of this.selected) {
        const payload = await EvaFacilityStatusTranslator.toPayload(
          this.$disaster.disaster_no,
          item,
          SaveType.factoryBulkEdit(),
          this.editedItem
        );
        list.push(
          evaFacilityStatusRepository
            .update(ScreenId.SF1407, payload)
            .then(response => {
              this.handleSuccess(response);
            })
            .catch(e => {
              this.handleUpdateError(e);
            })
        );
      }
      await Promise.all(list);
      await this.initialize(true);
      await this.closeBulkEdit();
    },

    closeBulkEdit() {
      this.$refs.bulkEditForm.resetValidation();
      this.dialogBulkEdit = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async bulkUpdate() {
      const message = `チェックした施設状況を一括で更新します。よろしいですか？`;
      const result = await this.$refs.confirmBulkUpdate.open(message, "更新", {
        width: 450
      });
      if (!result) {
        return false;
      }
      this.clearMessage();
      const list = [];
      for (const item of this.selected) {
        const payload = await EvaFacilityStatusTranslator.toPayload(
          this.$disaster.disaster_no,
          item,
          SaveType.factoryBulkUpdate()
        );
        list.push(
          evaFacilityStatusRepository
            .update(ScreenId.SF1407, payload)
            .then(response => {
              this.handleSuccess(response);
            })
            .catch(e => {
              this.handleUpdateError(e);
            })
        );
      }
      Promise.all(list).finally(() => {
        this.$nextTick(() => {
          this.initialize(true);
        });
      });
    },

    isSelected(selected) {
      return arrayCount(selected) > 0;
    },

    async editDatetime(title, item, itemKey) {
      item[itemKey] = await this.$refs.editDatetime.open(
        title,
        item[itemKey],
        this.screen.readOnly
      );
    },

    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmss");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    },

    hasFacilityClass(searchItem) {
      return !!searchItem.facilityClass;
    },

    hasMunicipality(searchItem) {
      return searchItem.municipality;
    },

    hasItems(searchItem, items) {
      if (!searchItem.municipality) {
        return false;
      }
      if (!items) {
        return false;
      }
      if (!Array.isArray(items)) {
        return false;
      }
      if (items.length < 1) {
        return false;
      }
      return items.some(
        item => item.facility_class === searchItem.facilityClass
      );
    },

    toggleOpeningStatus() {
      this.$nextTick(() => {
        if (this.likesAllOpeningStatus) {
          Object.assign(this.searchItem, { openingStatuses: [] });
        } else {
          Object.assign(this.searchItem, {
            openingStatuses: this.$facility.openingStatuses.slice()
          });
        }
      });
    },

    validateDatetime() {
      if (this.editedItem.valid_opening_date === false) {
        return false;
      }
      return this.editedItem.valid_closing_date !== false;
    },

    /**
     * チェックマークを操作した時の処理をまとめている
     * isSelectedは操作前の値が入力されていることに注意
     */
    changeCheckItem(item, isPreSelected) {
      // 変更前のデータを一時的に保存、編集キャンセル時に復元する
      if (isPreSelected) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].fa_id === item.fa_id) {
            // read_only_row:入力の可否を管理している変数はそのままだと入力可能となるので、変更
            this.editedItems[item.fa_id].read_only_row = true;
            this.$set(this.items, i, cloneDeep(this.editedItems[item.fa_id]));
            delete this.editedItems[item.fa_id];
            break;
          }
        }
      } else {
        this.editedItems[item.fa_id] = cloneDeep(item);
      }
    },
    /**検索時にページネーションをリセット
     * 初期表示ではテーブルが生成されていないためデータテーブルのメソッドが
     * 呼び出せない。生成されていることを確認してから呼びだす。
     */
    resetPage() {
      if (this.$refs.resetPagination) {
        this.$refs.resetPagination.resetPage();
      }
    },
    /**
     * 全体バリデーションリセット
     * ※操作方法によって両方のバリデーションリセットが必要になるため
     */
    resetValidationAll() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.bulkEditForm) {
        this.$refs.bulkEditForm.resetValidation();
      }
    },
    /**
     * 検索「原子力防災施設区分」「避難元所属市町村」「避難元所属地域（地区）」「市町村」
     * を検索時にチェックボックスをリセット
     */
    resetCheckItems() {
      // リセットするターゲット
      let selectedFaId = [];
      if (this.selected.length > 0) {
        this.selected.forEach(val => {
          selectedFaId.push(val.fa_id);
        });
        // リセットするターゲットをreadonlyにする
        for (let i = 0; i < selectedFaId.length; i++) {
          let res = "";
          res = this.items.findIndex(val => val.fa_id === selectedFaId[i]);
          if (!(res < 0)) {
            this.items[res].read_only_row = true;
          }
        }
      }
      this.selected = [];
      this.resetValidationAll();
      this.resetPage();
    },
    // 型変換メソッド※安定ヨウ素剤配布場所フラグチェックボックス用
    changeValType(value, toStringFlg = false) {
      if (toStringFlg) {
        // Booleanから数値（文字列）へ変換
        let BoolToNumber = Number(value);
        return String(BoolToNumber);
      } else {
        // 数値（文字列)からBooleanへ変換
        let NumberToBool = Number(value);
        return Boolean(NumberToBool);
      }
    }
  }
};
</script>
